// extracted by mini-css-extract-plugin
export var videoPlayButton = "Video-module--video-play-button--3xyyD";
export var videoHeading = "Video-module--video-heading--1kUcW";
export var bgDark = "Video-module--bg-dark--WpakA";